import React, { useEffect, useState, useRef, useMemo } from "react";
import Highcharts from "highcharts";
import {
  Modal,
  DatePicker,
  Select,
  Row,
  Col,
  Form,
  Input,
  Spin,
  message,
} from "antd";
import { Button } from "antd";
import filtericon from "../../../assets/images/filter-svgrepo-com (1).svg";
import ExportIcon from "../../../assets/images/export-svgrepo-com (1).svg";
import { Badge, Space, Avatar } from "antd";
import HighchartsReact from "highcharts-react-official";
import report from "../reports";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
import { ButtonFilled } from "../../../Reusablecomponents/UIButtons";
import dayjs from "dayjs";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";
import styled from "styled-components";
import { CSVLink } from "react-csv";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";

const StyledChartContainer = styled.div`
  .filterstyle {
    height: 20px;
    width: 20px;
  }
  ,
  .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  }
  ,
  .total-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
  }
`;
const { Option } = Select;
const { RangePicker } = DatePicker;

const ConsingmentReport = ({ Tabhidden, setTabHidden }) => {
  const [form] = Form.useForm();
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );

  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);

  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("TRPT", "EX"),
    [reduxPermissions],
  );
  const [tripConsignmentData, setTripConsignmentData] = useState([]);
  const [filterCount, setFilterCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState(null);
  const [ConsignmentChartData, setConsignmentChartData] = useState([]);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef();
  const [Total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const getTripConsignmentData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `trip/get_consignment_report?MCID=${userInfo?.MCID}&startDate=${dayjs(
          selectedDate[0],
        ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=${currentPage}&PageSize=${pageSize}`,
        {
          Vehid: formValues?.vehicle || 0,
          Cust: formValues?.consignor || 0,
          Shipper: formValues?.transporter || 0,
          Receiver: formValues?.consignee || 0,
          Triptype: formValues?.tripType || 0,
          Driver: formValues?.driver || 0,
          Tripcode: formValues?.tripcode || 0,
          code: formValues?.consigncode || 0,
        },
      );
      setTripConsignmentData(data);
      setTotal(data?.ConsignmentReportTable[0]?.TotalCount || 0);
      setLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  const formatMinutes = (value) => {
    if (value == null || isNaN(value)) return "-";
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };
  //export functionality for trip time reprt tabel
  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);

      const { data } = await CALL_API(
        "POST",
        `trip/get_consignment_report?MCID=${userInfo?.MCID}&startDate=${dayjs(
          selectedDate[0],
        ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=1&PageSize=${Total}`,
        {
          Vehid: formValues?.vehicle || 0,
          Cust: formValues?.consignor || 0,
          Shipper: formValues?.transporter || 0,
          Receiver: formValues?.consignee || 0,
          Triptype: formValues?.tripType || 0,
          Driver: formValues?.driver || 0,
          Tripcode: formValues?.tripcode || 0,
          code: formValues?.consigncode || 0,
        },
      );

      if (data?.ConsignmentReportTable.length > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data?.ConsignmentReportTable);

        setCSVList(
          sortedData?.map((item) => ({
            "Consign Code": item.code || "-",
            "Pickup Date & Time": item.pickupdatetime
              ? dayjs(item.pickupdatetime).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            Consignor: item.custname || "-",
            Consignee: item.recname || "-",
            Vehicle: item.Regno || "-",
            "Driver Name": item.drivername || "-",
            "Trip Type": item.triptype
              ? item.triptype === 1
                ? "Local"
                : "Safari"
              : "-",
            "Loading Cycle": formatMinutes(item.loadingcycle) || "-",
            Transporter: item.supname || "-",
            "Loading Waiting Time":
              formatMinutes(item.LOADINGWAITINGTIME) || "-",
            "Loading Time": formatMinutes(item.LOADINGTIME) || "-",
            "Time After Loading": formatMinutes(item.TIMEAFTERLOADING) || "-",
            "Offloading Waiting Time":
              formatMinutes(item.OFFLOADINGWAITINGTIME) || "",
            "Offloading Time": formatMinutes(item.OFFLOADINGTIME) || "-",
            "Time After Offloading":
              formatMinutes(item.TIMEAFTEROFFLOADING) || "-",
            "Offloading Cycle": formatMinutes(item.OFFLOADINGCYCLE) || "-",
            Started: item.Started
              ? dayjs(item.Started).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            "Arrived PickUp Point": item.ArrivedPickUpPoint
              ? dayjs(item.ArrivedPickUpPoint).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            "Loading Started": item.LoadingStarted
              ? dayjs(item.LoadingStarted).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            "Loading Completed": item.LoadingCompleted
              ? dayjs(item.LoadingCompleted).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            "Journey Started": item.JourneyStarted
              ? dayjs(item.JourneyStarted).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            "Reached Delivery Point": item.ReachedDeliveryPoint
              ? dayjs(item.ReachedDeliveryPoint).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            "Offloading Started": item.OffLoadingStarted
              ? dayjs(item.OffLoadingStarted).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            "Offloading Completed": item.OffLoadingCompleted
              ? dayjs(item.OffLoadingCompleted).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            "Return Journey Started": item.ReturnJourneyStarted
              ? dayjs(item.ReturnJourneyStarted).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            "Returned To Base": item.ReturnedtoBase
              ? dayjs(item.ReturnedtoBase).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            Finished: item.Finished
              ? dayjs(item.Finished).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          })),
        );

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
      message.error(
        "Failed to prepare CSV. " + (error?.response?.data?.message || ""),
      );
    } finally {
      setCSVLoader(false);
    }
  };

  //Format time calculation HH:MM
  const formatHHMM = (minutes) => {
    if (minutes == null || isNaN(minutes)) return "00:00";

    const days = Math.floor(minutes / 1440); // 1440 = 24 * 60
    const hours = Math.floor((minutes % 1440) / 60);
    const mins = minutes % 60;

    if (days > 0) {
      // Return DD:HH:MM
      return `${String(days).padStart(2, "0")}:${String(hours).padStart(
        2,
        "0",
      )}:${String(mins).padStart(2, "0")}`;
    }

    // Return HH:MM when no day exists
    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
  };

  const labels = tripConsignmentData?.ConsignmentLoadingTime?.map((item) => {
    const custName = consignerList?.find((val) => val.ID === item.CUST)?.Name;
    return custName;
  });

  const colors = [
    "rgb(255,102,102)",
    "rgb(108,167,255)",
    "rgb(175,207,102)",
    "rgb(214,255,117)",
    "rgb(190,190,190)",
    "rgb(117,244,255)",
  ];

  const dataValues =
    tripConsignmentData?.ConsignmentLoadingTime?.map(
      (item) => item.LoadingTime,
    ) || [];

  // Map data for Highcharts

  const total = dataValues.reduce((acc, val) => acc + val, 0); // Calculate total

  const seriesData = dataValues.map((value, index) => ({
    name: labels[index % labels.length],
    y: value,
    color: colors[index % colors.length],
  }));

  const options = {
    chart: {
      type: "pie",
      backgroundColor: "white",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: "50%",
        dataLabels: {
          enabled: true,
          distance: 50,
          connectorColor: "gray",
          connectorWidth: 2,
          useHTML: true,
          formatter: function () {
            const percentage = ((this.point.y / total) * 100).toFixed(1); // One decimal place
            const formattedTime = formatHHMM(this.point.y);
            return `
              <div style="display: flex; align-items: center;">
                <div style="
                  width: 10px;
                  height: 10px;
                  background-color: ${this.point.color};
                  border-radius: 80%;
                  margin-right: 5px;
                "></div>
                <span style="color:#5F6D8C;">
                  ${this.point.name}: <b>${formattedTime} (${percentage}%)</b>
                </span>
              </div>
            `;
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        const percentage = ((this.point.y / total) * 100).toFixed(1);
        const formattedTime = formatHHMM(this.point.y);
        return `
          <div style="display: flex; align-items: center;">
            <div style="
              width: 10px;
              height: 10px;
              background-color: ${this.point.color};
              border-radius: 50%;
              margin-right: 5px;
            "></div>
            <span style="color: #5F6D8C;">${this.point.name}: <b>${formattedTime} (${percentage}%)</b></span>
          </div>
        `;
      },
    },
    series: [
      {
        name: "Data Series",
        data: seriesData,
      },
    ],
  };

  const labels1 = [`UnAssigned`, `Assigned`, `Inprogress`, `Completed`];

  const colors1 = [
    "rgb(255,102,102)",
    "rgb(108,167,255)",
    "rgb(175,207,102)",
    "rgb(214,255,117)",
    "rgb(190,190,190)",
    "rgb(117,244,255)",
  ];

  const dataValues1 = [
    tripConsignmentData?.ConsignmentStatusChart?.[0]?.Unassigned,
    tripConsignmentData?.ConsignmentStatusChart?.[0]?.Assigned,
    tripConsignmentData?.ConsignmentStatusChart?.[0]?.Inprogress,
    tripConsignmentData?.ConsignmentStatusChart?.[0]?.Completed,
  ].map((value) => Number(value));

  const seriesData1 = dataValues1.map((value, index) => ({
    name: labels1[index % labels1.length],
    y: value,
    color: colors1[index % colors1.length],
  }));

  const options1 = {
    chart: {
      type: "pie",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: "50%",
        startAngle: -90,
        endAngle: 90,
        center: ["50%", "75%"],
        dataLabels: {
          enabled: true,
          connectorColor: "gray", // Connector line color
          connectorWidth: 1,
          useHTML: true,
          formatter: function () {
            return `
              <div style="display: flex; align-items: center;">
                <div style="
                  width: 10px;
                  height: 10px;
                  background-color: ${this.point.color};
                  border-radius: 50%;
                  margin-right: 5px;
                "></div>
                <span     style="
                color:#5F6D8C;
                  "  >    ${this.point.name}: 
                  <b>${this.point.y}</b>
                  </span>
              </div>
            `;
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        return `
          <div style="display: flex; align-items: center;">
            <div style="
              width: 10px;
              height: 10px;
              background-color: ${this.point.color};
              border-radius: 50%;
              margin-right: 5px;
            "></div>
            <span>${this.point.name}: <b>${this.point.y}</b></span>
          </div>
        `;
      },
    },
    series: [
      {
        name: "Data Series 1",
        data: seriesData1,
      },
    ],
  };

  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(value).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };
  // const formatTotalDuration = (totalSeconds) => {
  //   if (!totalSeconds || totalSeconds <= 0) return "00:00";

  //   const days = Math.floor(totalSeconds / (60 * 60 * 24));
  //   const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / 3600);
  //   const minutes = Math.floor((totalSeconds % 3600) / 60);
  //   const seconds = totalSeconds % 60;

  //   const formattedHours = hours.toString().padStart(2, "0");
  //   const formattedMinutes = minutes.toString().padStart(2, "0");
  //   const formattedSeconds = seconds.toString().padStart(2, "0");

  //   if (days > 0) {
  //     return `${days}d(${formattedHours}:${formattedMinutes})`;
  //   } else if (hours > 0 || minutes > 0) {
  //     return `${formattedHours}:${formattedMinutes}`;
  //   } else {
  //     return `00:${formattedSeconds}`;
  //   }
  // };
  const formatTotalDuration = (totalSeconds) => {
    if (!totalSeconds || totalSeconds <= 0) return "00:00:00";

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const hh = hours.toString().padStart(2, "0");
    const mm = minutes.toString().padStart(2, "0");
    const ss = seconds.toString().padStart(2, "0");

    return `${hh}:${mm}:${ss}`;
  };

  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle numeric fields
      if (
        [
          "loadingcycle",
          "triptype",
          "OFFLOADINGCYCLE",
          "TIMEAFTEROFFLOADING",
          "OFFLOADINGWAITINGTIME",
          "TIMEAFTERLOADING",
          "LOADINGWAITINGTIME",
        ].includes(tableSort.field)
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };

  const columns = [
    {
      title: "Consign Code",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => (a.code || "").localeCompare(b.code || ""),
      sortOrder: tableSort.field === "code" ? tableSort.order : null,
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Pickup Date & Time",
      dataIndex: "pickupdatetime",
      key: "pickupdatetime",
      sorter: (a, b) =>
        (a.pickupdatetime || "").localeCompare(b.pickupdatetime || ""),
      sortOrder: tableSort.field === "pickupdatetime" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "Consignor",
      dataIndex: "custname",
      key: "custname",
      sorter: (a, b) => (a.custname || "").localeCompare(b.custname || ""),
      sortOrder: tableSort.field === "custname" ? tableSort.order : null,
    },
    {
      title: "Consignee",
      dataIndex: "recname",
      key: "recname",
      sorter: (a, b) => (a.recname || "").localeCompare(b.recname || ""),
      sortOrder: tableSort.field === "recname" ? tableSort.order : null,
    },
    {
      title: "Vehicle",
      dataIndex: "Regno",
      key: "Regno",
      sorter: (a, b) => (a.Regno || "").localeCompare(b.Regno || ""),
      sortOrder: tableSort.field === "Regno" ? tableSort.order : null,
    },
    {
      title: "Driver Name",
      dataIndex: "drivername",
      key: "drivername",
      sorter: (a, b) => (a.drivername || "").localeCompare(b.drivername || ""),
      sortOrder: tableSort.field === "drivername" ? tableSort.order : null,
    },
    {
      title: "Trip Type",
      dataIndex: "triptype",
      key: "triptype",
      sorter: (a, b) => (a.triptype || 0) - (b.triptype || 0),
      sortOrder: tableSort.field === "triptype" ? tableSort.order : null,
      render: (type) => (type === 1 ? "Local" : "Safari"),
    },
    // {
    //   title: "ODO (Km)",
    //   dataIndex: "ODOKMS",
    //   key: "ODOKMS",
    //   render: (type) => (type ? type : "-"),
    // },
    {
      title: "Loading Cycle",
      dataIndex: "loadingcycle",
      key: "loadingcycle",
      sorter: (a, b) => (a.loadingcycle || 0) - (b.loadingcycle || 0),
      sortOrder: tableSort.field === "loadingcycle" ? tableSort.order : null,
      render: (value) => (value ? formatTotalDuration(value) : "-"),
    },
    {
      title: "Offloading Cycle",
      dataIndex: "OFFLOADINGCYCLE",
      key: "OFFLOADINGCYCLE",
      sorter: (a, b) => (a.OFFLOADINGCYCLE || 0) - (b.OFFLOADINGCYCLE || 0),
      sortOrder: tableSort.field === "OFFLOADINGCYCLE" ? tableSort.order : null,
      render: (value) => (value ? formatTotalDuration(value) : "-"),
    },
    {
      title: "Loading Time",
      dataIndex: "LOADINGTIME",
      key: "LOADINGTIME",
      sorter: (a, b) => (a.LOADINGTIME || 0) - (b.LOADINGTIME || 0),
      sortOrder: tableSort.field === "LOADINGTIME" ? tableSort.order : null,
      render: (value) => (value ? formatTotalDuration(value) : "-"),
    },
    {
      title: "Offloading Time",
      dataIndex: "OFFLOADINGTIME",
      key: "OFFLOADINGTIME",
      sorter: (a, b) => (a.OFFLOADINGTIME || 0) - (b.OFFLOADINGTIME || 0),
      sortOrder: tableSort.field === "OFFLOADINGTIME" ? tableSort.order : null,
      render: (value) => (value ? formatTotalDuration(value) : "-"),
    },
    {
      title: "Loading Waiting Time",
      dataIndex: "LOADINGWAITINGTIME",
      key: "LOADINGWAITINGTIME",
      sorter: (a, b) =>
        (a.LOADINGWAITINGTIME || 0) - (b.LOADINGWAITINGTIME || 0),
      sortOrder:
        tableSort.field === "LOADINGWAITINGTIME" ? tableSort.order : null,
      render: (value) => (value ? formatTotalDuration(value) : "-"),
    },
    {
      title: "Time After Loading",
      dataIndex: "TIMEAFTERLOADING",
      key: "TIMEAFTERLOADING",
      sorter: (a, b) => (a.TIMEAFTERLOADING || 0) - (b.TIMEAFTERLOADING || 0),
      sortOrder:
        tableSort.field === "TIMEAFTERLOADING" ? tableSort.order : null,
      render: (value) => (value ? formatTotalDuration(value) : "-"),
    },
    {
      title: "Offloading Waiting Time",
      dataIndex: "OFFLOADINGWAITINGTIME",
      key: "OFFLOADINGWAITINGTIME",
      sorter: (a, b) =>
        (a.OFFLOADINGWAITINGTIME || 0) - (b.OFFLOADINGWAITINGTIME || 0),
      sortOrder:
        tableSort.field === "OFFLOADINGWAITINGTIME" ? tableSort.order : null,
      render: (value) => (value ? formatTotalDuration(value) : "-"),
    },
    {
      title: "Time After Offloading",
      dataIndex: "TIMEAFTEROFFLOADING",
      key: "TIMEAFTEROFFLOADING",
      sorter: (a, b) =>
        (a.TIMEAFTEROFFLOADING || 0) - (b.TIMEAFTEROFFLOADING || 0),
      sortOrder:
        tableSort.field === "TIMEAFTEROFFLOADING" ? tableSort.order : null,
      render: (value) => (value ? formatTotalDuration(value) : "-"),
    },
    {
      title: "Started",
      dataIndex: "Started",
      key: "Started",
      sorter: (a, b) => (a.Started || "-").localeCompare(b.Started || "-"),
      sortOrder: tableSort.field === "Started" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "Arrive at pick-up point",
      dataIndex: "ArrivedPickUpPoint",
      key: "ArrivedPickUpPoint",
      sorter: (a, b) =>
        (a.ArrivedPickUpPoint || "").localeCompare(b.ArrivedPickUpPoint || ""),
      sortOrder:
        tableSort.field === "ArrivedPickUpPoint" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "Loading Started",
      dataIndex: "LoadingStarted",
      key: "LoadingStarted",
      sorter: (a, b) =>
        (a.LoadingStarted || "").localeCompare(b.LoadingStarted || ""),
      sortOrder: tableSort.field === "LoadingStarted" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "Loading Completed",
      dataIndex: "LoadingCompleted",
      key: "LoadingCompleted",
      sorter: (a, b) =>
        (a.LoadingCompleted || "").localeCompare(b.LoadingCompleted || ""),
      sortOrder:
        tableSort.field === "LoadingCompleted" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "Journey Started",
      dataIndex: "JourneyStarted",
      key: "JourneyStarted",
      sorter: (a, b) =>
        (a.JourneyStarted || "").localeCompare(b.JourneyStarted || ""),
      sortOrder: tableSort.field === "JourneyStarted" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";

        const dateString = date.toLocaleDateString("en-US", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });

        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });

        return `${dateString} ${timeString}`;
      },
    },
    {
      title: "Reached Delivery Point",
      dataIndex: "ReachedDeliveryPoint",
      key: "ReachedDeliveryPoint",
      sorter: (a, b) =>
        (a.ReachedDeliveryPoint || "").localeCompare(
          b.ReachedDeliveryPoint || "",
        ),
      sortOrder:
        tableSort.field === "ReachedDeliveryPoint" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "Offloading Started",
      dataIndex: "OffLoadingStarted",
      key: "OffLoadingStarted",
      sorter: (a, b) =>
        (a.OffLoadingStarted || "").localeCompare(b.OffLoadingStarted || ""),
      sortOrder:
        tableSort.field === "OffLoadingStarted" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "OffLoading Completed",
      dataIndex: "OffLoadingCompleted",
      key: "OffLoadingCompleted",
      sorter: (a, b) =>
        (a.OffLoadingCompleted || "").localeCompare(
          b.OffLoadingCompleted || "",
        ),
      sortOrder:
        tableSort.field === "OffLoadingCompleted" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "Return Journey Started",
      dataIndex: "ReturnJourneyStarted",
      key: "ReturnJourneyStarted",
      sorter: (a, b) =>
        (a.ReturnJourneyStarted || "").localeCompare(
          b.ReturnJourneyStarted || "",
        ),
      sortOrder:
        tableSort.field === "ReturnJourneyStarted" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "Returned to Base",
      dataIndex: "ReturnedtoBase",
      key: "ReturnedtoBase",
      sorter: (a, b) =>
        (a.ReturnedtoBase || "").localeCompare(b.ReturnedtoBase || ""),
      sortOrder: tableSort.field === "ReturnedtoBase" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
    {
      title: "Finished",
      dataIndex: "Finished",
      key: "Finished",
      sorter: (a, b) => (a.Finished || "").localeCompare(b.Finished || ""),
      sortOrder: tableSort.field === "Finished" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        if (isNaN(date.getTime())) return "-";
        const options = { day: "numeric", month: "short", year: "numeric" };
        const dateString = date.toLocaleDateString("en-US", options);
        const timeString = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return (
          <div>
            <div>{dateString}</div>
            <div style={{ fontStyle: "italic", color: "#7d8da1" }}>
              {timeString}
            </div>
          </div>
        );
      },
    },
  ];

  const handleClick = () => {
    setTabHidden(true);
  };
  const handleClickreport = () => {
    setTabHidden(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  useEffect(() => {
    getTripConsignmentData();
  }, [selectedDate, formValues, pageSize, currentPage]);

  return (
    <>
      <StyledChartContainer>
        <div>
          <div style={report.reportleftcontainer}>
            <Button
              type="primary"
              onClick={() => handleClick()}
              style={report.tripbtn}
            >
              Trip Time Report
            </Button>

            <Button
              type="primary"
              onClick={() => handleClickreport()}
              style={report.consingmentbtn}
            >
              Consignment Report
            </Button>
          </div>

          <div style={report.firstcontan}>
            <div style={report.overview}>
              <span>Overview</span>
            </div>

            <div style={report.controls}>
              <div style={report.subcontainer}>
                <Select
                  style={{ width: "240px" }}
                  defaultValue={duration}
                  onChange={(values) => {
                    setDuration(values);
                  }}
                >
                  {Duration.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item?.label}
                    </Option>
                  ))}
                </Select>
              </div>

              <div style={report.subcontainer}>
                <RangePicker
                  value={selectedDate}
                  onChange={(date, dateString) => setSelectedDate(date)}
                />
              </div>

              <div style={report.subcontainer}>
                <Button style={report.filterbtn} onClick={showModal}>
                  <Space size="middle">
                    <Badge size="small" count={filterCount}>
                      <Avatar
                        shape="circle"
                        size="medium"
                        src={filtericon}
                        className="filterstyle"
                      />
                    </Badge>
                  </Space>
                </Button>
              </div>
              <Modal
                open={isModalOpen}
                onCancel={handleCancel}
                width={900}
                footer={
                  <ButtonFilled
                    onClick={() => {
                      form.resetFields();
                      setFormValues({});
                    }}
                  >
                    {" "}
                    Clear All{" "}
                  </ButtonFilled>
                }
              >
                <Row>
                  <Col xl={24} xs={{ span: 24, order: 2 }}>
                    <div className="container_for_kpi_filter">
                      <h6 className="Filter_for_clickablerow">
                        Filter ({filterCount})
                      </h6>
                      {/* <p className="Filter_for_Result">4 Result Found </p> */}
                    </div>
                  </Col>
                </Row>
                <Form
                  form={form}
                  layout="vertical"
                  onValuesChange={(value, allvalues) => {
                    getFilterCount();
                    setFormValues(allvalues);
                  }}
                >
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={6}>
                      <Form.Item label="Vehicle" name="vehicle">
                        <Select
                          className="w-100"
                          showSearch
                          optionFilterProp="children"
                          options={vehicleList?.map((item) => ({
                            label: item.REGNO,
                            value: item.VEHID,
                          }))}
                          filterOption={(input, option) =>
                            option?.label
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          allowClear
                          // suffixIcon={<SearchOutlined className="search_icon" />}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={6}>
                      <Form.Item label="Consignor" name="consignor">
                        <Select
                          className="w-100"
                          showSearch
                          optionFilterProp="children"
                          options={consignerList?.map((item) => ({
                            label: item.Name,
                            value: item.ID,
                          }))}
                          filterOption={(input, option) =>
                            option?.label
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          allowClear
                          // suffixIcon={<SearchOutlined className="search_icon" />}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={6}>
                      <Form.Item label="Transporter" name="transporter">
                        <Select
                          className="w-100"
                          showSearch
                          optionFilterProp="children"
                          options={transporterList?.map((item) => ({
                            label: item.Name,
                            value: item.ID,
                          }))}
                          filterOption={(input, option) =>
                            option?.label
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          allowClear
                          // suffixIcon={<SearchOutlined className="search_icon" />}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={6}>
                      <Form.Item label="Consignee" name="consignee">
                        <Select
                          className="w-100"
                          showSearch
                          optionFilterProp="children"
                          options={consigneeList?.map((item) => ({
                            label: item.Name,
                            value: item.ID,
                          }))}
                          filterOption={(input, option) =>
                            option?.label
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          allowClear
                          // suffixIcon={<SearchOutlined className="search_icon" />}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={6}>
                      <Form.Item label="Consign Code" name="consigncode">
                        <Input placeholder="" className="rounded-pill" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={6}>
                      <Form.Item label="Trip Code" name="tripcode">
                        <Input placeholder="" className="rounded-pill" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={6}>
                      <Form.Item label="Trip Type" name="tripType">
                        <Select
                          className="w-100"
                          showSearch
                          allowClear
                          // suffixIcon={<SearchOutlined className="search_icon" />}
                        >
                          <Option value={2}>Safari</Option>
                          <Option value={1}>Local</Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={6}>
                      <Form.Item label="Driver" name="driver">
                        <Select
                          className="w-100"
                          showSearch
                          optionFilterProp="children"
                          options={driverList?.map((item) => ({
                            label: item.FULLNM,
                            value: item.UID,
                          }))}
                          filterOption={(input, option) =>
                            option?.label
                              ?.toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          allowClear
                          // suffixIcon={<SearchOutlined className="search_icon" />}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Modal>
            </div>
          </div>
        </div>

        <div style={report.charthalf}>
          <div id="Export Chart1">
            <Spin spinning={loading}>
              <div className="chart-header">
                <h6 style={report.consingmentstatus}>Consignment Status </h6>
                <img
                  src={ExportIcon}
                  alt="Export"
                  style={{
                    width: "20px",
                    height: "20px",
                    cursor: exportAllowed ? "pointer" : "not-allowed",
                    marginRight: "40px",
                    backgroundColor: "#EBF7ED",
                    borderRadius: "6px",
                  }}
                  onClick={() => {
                    if (!exportAllowed) return;
                    handleDownloadChart("Export Chart1", "Consignment Status");
                  }}
                />
              </div>
              <div>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={options1}
                />{" "}
              </div>
            </Spin>
          </div>
        </div>

        <div style={report.loadingtimechart}>
          <div id="Export Chart">
            <Spin spinning={loading}>
              <div className="chart-header">
                <h6 style={report.loadingtime}>Loading Time </h6>
                <img
                  src={ExportIcon}
                  alt="Export"
                  style={{
                    width: "20px",
                    height: "20px",
                    cursor: exportAllowed ? "pointer" : "not-allowed",
                    marginRight: "40px",
                    backgroundColor: "#EBF7ED",
                    borderRadius: "6px",
                  }}
                  onClick={() => {
                    if (!exportAllowed) return;
                    handleDownloadChart("Export Chart", "Consignment Status");
                  }}
                />
              </div>
              <HighchartsReact highcharts={Highcharts} options={options} />
            </Spin>
          </div>
        </div>
        <div className="total">
          <div className="total-header">
            <div className="table-head">
              <h6> {tripConsignmentData.length}Consignment Report</h6>
            </div>
            <div className="Custom">
              <Spin spinning={CSVLoader}>
                <img
                  src={ExportIcon}
                  alt="Export"
                  style={{
                    width: "20px",
                    height: "20px",
                    cursor: exportAllowed ? "pointer" : "not-allowed",
                    marginRight: "40px",
                    backgroundColor: "#EBF7ED",
                    borderRadius: "6px",
                  }}
                  onClick={() => {
                    if (!exportAllowed) return;
                    prepareCSV();
                  }}
                />
              </Spin>
              <CSVLink
                data={CSVList}
                filename={"ConsignmentReportTable.csv"}
                asyncOnClick={true}
                ref={csvLinkEl}
              />
            </div>
          </div>
        </div>
        <div style={report.table}>
          <Spin spinning={loading}>
            <StyledTable
              className="mt-4"
              dataSource={tripConsignmentData?.ConsignmentReportTable}
              columns={columns}
              pagination={false}
              style={{
                cursor: "default",
              }}
              onChange={(pagination, filters, sorter) => {
                setTableSort({
                  field: sorter.field,
                  order: sorter.order,
                });
              }}
            />
            <ReusablePagination
              pageSize={pageSize}
              handlePageSizeChange={handlePageSizeChange}
              currentPage={currentPage}
              total={Total}
              handlePageChange={handlePageChange}
            />
          </Spin>
        </div>
      </StyledChartContainer>
    </>
  );
};

export default ConsingmentReport;
